import { render, staticRenderFns } from "./UnmannedDays.vue?vue&type=template&id=78287998&scoped=true"
import script from "./UnmannedDays.vue?vue&type=script&lang=js"
export * from "./UnmannedDays.vue?vue&type=script&lang=js"
import style0 from "./UnmannedDays.vue?vue&type=style&index=0&id=78287998&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78287998",
  null
  
)

export default component.exports